import React from "react";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";

import "./PaymentMessage.css";
import { NavLink } from "react-router-dom";
const PaymentMessage = (props) => {
  return (
    <div className="payment-container">
      <div
        className={`payment-message-container alert-${
          props.success ? "success" : "danger"
        }`}
      >
        <div
          className="alert-heading text-center"
          style={{ fontSize: "2rem", fontWeight: "bold" }}
        >
          {props.messageHeading}
        </div>
        <div className="payment-message-description">
          <p className="px-2">
            {props.messageDescription}
            {props.success ? <CheckIcon /> : <ClearIcon />}
          </p>
        </div>
      </div>
      <hr />
      <div className="payment-container-footer text-center">
        Return to <NavLink to="/">Home page</NavLink>
      </div>
    </div>
  );
};

export default PaymentMessage;
